import axios from 'axios';

// Use environment variable or fallback to production domain
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://adminapi.instantassist.cloud/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add error logging
apiClient.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error.message);
    if (error.response?.status === 401) {
      // Handle unauthorized
      localStorage.removeItem('authToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const authApi = {
  login: (password) => apiClient.post('/auth/login', { password }),
  logout: () => apiClient.post('/auth/logout'),
};

// User APIs
export const userApi = {
  getList: () => apiClient.get('/users/list'),
  getAll: () => apiClient.get('/users'),
  getById: (id) => apiClient.get(`/users/${id}`),
  getAppStatus: (id) => apiClient.get(`/users/${id}/app-status`),
  getBatchAppStatus: (userIds) => apiClient.post('/users/batch/app-status', { userIds }),
  toggleAppStatus: (id) => apiClient.put(`/users/${id}/app-status`),
  create: (data) => apiClient.post('/users', data),
  update: (id, data) => apiClient.put(`/users/${id}`, data),
  delete: (id) => apiClient.delete(`/users/${id}`),
};

export default apiClient;
